module.exports = __webpack_public_path__ + "static/media/frown-open.b324d79c.svg";